// extracted by mini-css-extract-plugin
export default {"mobile":"style-module--mobile--757d1","desktop":"style-module--desktop--5e4b5"};